export interface IExpenseMasterModel {
  businessTransactionID: number
  expenseTypeID: number
  bTransTypeID: number
  bTransTypeName: string
  expenseName: string
  expenseTitle: string
  descriptions: string
  transactionMode: string
  amount: number
  transactionDate: string
}

export const expenseMasterInitValues: IExpenseMasterModel = {
  businessTransactionID: 0,
  expenseTypeID: 0,
  bTransTypeID: 0,
  bTransTypeName: '',
  expenseName: '',
  expenseTitle: '',
  descriptions: '',
  transactionMode: '',
  amount: 0,
  transactionDate: '',
}

export interface IExpensedTypeDropDown {
  expenseTypeID: number
  expenseName: string
}
export const expenseTypeDropDownIniValues: IExpensedTypeDropDown = {
  expenseTypeID: 0,
  expenseName: '',
}
export interface ITypeDropDown {
  bTransTypeID: number
  bTransTypeName: string
}
export const typeDropDownIniValues: ITypeDropDown = {
  bTransTypeID: 0,
  bTransTypeName: '',
}
